// How a take is named to a person beside its number: when it was recorded and
// with which model — «recorded 2026-10-22 20:09:35 · gemini-2.5-pro-preview-tts
// · #1108», the time as the studio's list of takes prints it. A number alone says nothing to someone judging a recording (and
// hid, on 23.10.2026, that three passes showed the same old take); the studio
// lists every take by its time, so the fragments do too. Shared by the server
// (chat messages and stages, in the server's local time — the studio's) and
// the Tasks screen (the browser's).
//
//   take  {fragmentVersionId | versionId | id, recordedAt (ISO or Date) | null, model | null}
//   opts  {id: false} leaves the number out; {reused: true} says the take was
//         not made now but shown again

// The studio's own stamp (AudioStudio.js versionName): «2026-10-22 20:09:35»,
// seconds included — takes of one pass are minutes or seconds apart.
function fmtWhen(s) {
  if (!s) return '';
  const d = new Date(s);
  if (isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

// The model by its version alone («3.1» for gemini-3.1-flash-tts-preview):
// what a list of takes of one field needs to tell them apart.
function shortModel(model) {
  const m = /(\d+(?:\.\d+)?)/.exec(String(model || ''));
  return m ? m[1] : String(model || '');
}

//   opts  {short: true} — for a list of takes side by side: no «recorded», the model by its version
function takeStamp(take, { id = true, reused = false, short = false } = {}) {
  const t = take || {};
  const n = t.fragmentVersionId || t.versionId || t.id || null;
  const parts = [];
  const when = fmtWhen(t.recordedAt);
  if (when) parts.push(short ? when : `recorded ${when}`);
  if (t.model) parts.push(short ? shortModel(t.model) : String(t.model));
  if (id && n) parts.push(`#${n}`);
  if (reused) parts.push('shown again, not recorded now');
  return parts.join(' · ') || (n ? `#${n}` : 'take');
}

module.exports = { takeStamp, fmtWhen, shortModel };
